import React from 'react';
import SocialIcon from './SocialIcon';
import './SocialList.css';

export default ({ socialItems }) => (
  <div className="social-list">
    {socialItems.map(({ nombre, url }, i) => (
      <SocialIcon key={i} name={nombre} url={url} isLink={true} />
    ))}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/SocialList.js